import { Route, Routes } from 'react-router-dom';
import { RateList } from './list';
import { RateDetails } from './id';
import { CreateRate } from './create';

export function ServicesRatesTab({ warehouseId }) {
  return (
    <div className="py-3">
      <Routes>
        <Route index element={<RateList warehouseId={warehouseId} />} />
        <Route path="create" element={<CreateRate />} />
        <Route path=":id" element={<RateDetails />} />
      </Routes>
    </div>
  );
}
